import { ADD_LICENCE_SUCCESS, ADD_LICENCE_FAILURE } from '../constants/MTag';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case ADD_LICENCE_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
			};
		case ADD_LICENCE_FAILURE:
			return {
				...state,
				isLoading: false,
				errorData: action.payload,
				error: true,
			};
		default:
			return { ...state };
	}
};
